<!--<template>-->
<!--  <span @click="open" style="display: inline-block;">-->
<!--    <template v-if="!pure">-->
<!--      <slot name="button">-->
<!--        <button>{{ buttonConfig.text }}</button>-->
<!--      </slot>-->
<!--    </template>-->
<!--    <div v-if="renderModal">-->
<!--      <Modal-->
<!--        ref="Modal"-->
<!--        v-model="showModal"-->
<!--        v-bind="modalConfig"-->
<!--        loading-->
<!--        @on-ok="ok"-->
<!--        @on-cancel="cancel"-->
<!--      >-->
<!--        <Spin fix v-if="loading"></Spin>-->
<!--        <slot></slot>-->
<!--        <slot name="footer" slot="footer"></slot>-->
<!--        <slot name="header" slot="header"></slot>-->
<!--        <slot name="close" slot="close"></slot>-->
<!--      </Modal>-->
<!--    </div>-->
<!--  </span>-->
<!--</template>-->

<script>
export default {
  name: 'ModalOperator',

  render(h) {
    function c(elements, options) {
      if (!elements) return null
      return h('span', options, elements)
    }

    // 点击按钮
    const buttonProps = {
      size: 'small',
      disabled: this.disabled,
    }
    const button = this.pure ? undefined : c(this.$parent.$slots.default ||
        this.$slots.button, { propsData: buttonProps }) ||
        h('Button', { props: buttonProps }, this.buttonConfig.text)

    // 等待动画
    const spin = this.loading ? h('Spin', {
      props: { fix: true },
    }) : undefined

    // 内容
    const content = this.$slots.default

    return h('span', {
      on: {
        click: (e) => {
          e.stopPropagation()
          this.open()
        },
      },
    }, [
      button,
      this.createModal(h, [
        spin,
        content,
        c(this.$slots.header, { slot: 'header' }),
        c(this.$slots.footer, { slot: 'footer' }),
        c(this.$slots.close, { slot: 'close' }),
      ]),
    ])
  },

  props: {
    pure: Boolean,
    config: Object,
  },

  data() {
    return {
      loading: false,
      buttonLoading: false,
      // 为了避免在页面上渲染过多的Modal
      renderModal: false,
      showModal: false,
      submitName: '',
    }
  },

  computed: {
    modalConfig() {
      const config = {}
      if (!this.pure) {
        Object.assign(config, this.config, this.$parent.$attrs['modal-config'])
      } else {
        return this.config
      }
      return config
    },
    buttonConfig() {
      if (this.pure) return
      return Object.assign({ text: '按钮' }, this.$parent.$attrs['button-config'])
    },
  },

  provide() {
    return {
      $Modal: this,
    }
  },

  inject: {
    $Container: {
      from: '$Container',
      default: undefined,
    },
  },

  methods: {
    createModal(h, children) {
      if (!this.renderModal) return
      return h('span', [
        h('Modal', {
          ref: 'Modal',
          props: {
            maskClosable: false,
            value: this.showModal,
            ...this.modalConfig,
            loading: true,
          },
          on: {
            'on-ok': this.ok,
            'on-cancel': this.cancel,
          },
        }, children),
      ])
    },
    close() {
      this.showModal = false

      // 需要在下次渲染时清除Modal，否正Modal关闭动作会被中断
      this.$nextTick(() => {
        this.renderModal = false
      })

      // 纯净模式下需要额外操作清理DOM
      if (this.pure) {
        document.body.removeChild(this.$refs.Modal.$el)
        this.$destroy()
      }
    },
    cancelLoading() {
      this.buttonLoading = false
      this.$refs.Modal.buttonLoading = false
    },
    async open(el) {
      // 打开窗口前
      const result = await this.run('beforeOpen')
      if (result === false) return

      // 渲染弹窗
      this.renderModal = true
      this.loading = true

      // 需要等待下一次渲染时机去打开弹窗
      this.$nextTick(async() => {
        this.showModal = true
        // 纯净模式下手动添加DOM
        if (this.pure) {
          document.body.appendChild(this.$refs.Modal.$el)
        }
        // 打开窗口后
        await this.run('afterOpen')
        this.loading = false
      })
    },
    async ok(name = 'submit') {
      this.submitName = name
      this.buttonLoading = true

      try {
        // 校验
        const valid = await this.run('beforeSubmit', name)
        if (valid === false) {
          return this.cancelLoading()
        }

        // 提交
        const result = await this.run(name)
        this.cancelLoading()
        const vm = this.pure ? this : this.$parent
        vm.$emit('success', result)
        this.close()
      } catch (e) {
        this.$Message.error({
          content: e.message,
        })
        this.cancelLoading()
      }
    },
    cancel() {
      const vm = this.pure ? this : this.$parent
      vm.$emit('cancel')
      this.close()
    },
    run(name, ...args) {
      const vm = this.$Container ? this.$Container.$refs.Content : this.$parent
      if (!vm || !name) return
      if (vm[name] instanceof Function) {
        return vm[name](...args)
      }
    },
  },
}
</script>
